import type { CssGeneratorContext } from '../css-generator.model';
import type { InspectionTagTokens } from './tokens';

/** A pill colour group of `inspectionTag`. */
type InspectionTagTone = Exclude<keyof InspectionTagTokens, 'color'>;

const tone = (dt: CssGeneratorContext['dt'], name: string, token: InspectionTagTone) => `
.inspection-tag-${name} {
  background-color: ${dt(`inspectionTag.${token}.background`)};
  border-color: ${dt(`inspectionTag.${token}.borderColor`)};
  color: ${dt('inspectionTag.color')};
}`;

export const styles = ({ dt }: CssGeneratorContext) => `${tone(dt, 'scheduled', 'scheduled')}
${tone(dt, 'unscheduled', 'unscheduled')}
${tone(dt, 'inspection', 'inspection')}
${tone(dt, 'supervision', 'supervision')}
${tone(dt, 'monitoring', 'monitoring')}
`;
